export const getBreadCrumb = (nodeId: string, allNodes: any[], allEdges: any) => {
  let path: any[] = [];
  let searching = true;
  let currentNodeId = nodeId;
  while (searching) {
    const currentNode = allNodes.find((singleNode) => singleNode.id === currentNodeId);
    if (!currentNode) break;
    const sourceEdges: any[] = allEdges.filter(
      (singleEdge: any) =>
        singleEdge?.target === currentNodeId && singleEdge?.source !== currentNodeId && !singleEdge.hidden,
    );
    const sourceEdge =
      sourceEdges.find((singleEdge) =>
        getParentNodeType(currentNode?.type).includes(
          allNodes.find((singleNode) => singleNode.id === singleEdge.source)?.type,
        ),
      ) ?? sourceEdges[0];
    if (!sourceEdge) break;
    const sourceNode = allNodes.find((singleNode) => singleNode.id === sourceEdge.source);
    if (sourceNode) {
      path = [sourceNode, ...path];
      currentNodeId = sourceNode.id;
      if (sourceNode.type === 'AccountNode') {
        searching = false;
        break;
      }
    } else {
      searching = false;
      break;
    }
  }
  return path;
};

const getParentNodeType = (currentType: string) => {
  if (currentType === 'EventNode') return ['EventBridgeNode'];
  if (currentType === 'EventBridgeNode') return ['EventBridgeNode', 'RecordNode'];
  if (currentType === 'RecordNode') return ['BridgeNode'];
  if (currentType === 'BridgeNode') return ['AccountNode'];
  return [];
};
